<sh-text class="information-header" size="title-1">
  {{ 'label.coilInformation' | translate }} {{ coil.coilName }}
</sh-text>

<div class="information-grid">
  <div>
    {{ 'label.coilMaterialNumber' | translate }}
  </div>
  <div>
    {{ 'label.coilSerialNumber' | translate }}
  </div>

  <div
    class="replacement-part-label"
    [ngClass]="{
      replacement: isReplacementCoilMaterialNumber(+coil.coilMaterialNumber),
    }"
  >
    {{ 'label.replacementPart' | translate }}
  </div>

  <div
    [style.visibility]="isRelevantInfoVisible(coil?.coilName)"
    class="relevant-information-label"
    style="white-space: nowrap"
    innerHTML="{{ 'label.relevantInformation' | translate }}"
  ></div>
  <div class="label-coil-material-number">
    <ng-container
      *ngIf="
        isReplacementCoilMaterialNumber(+coil.coilMaterialNumber);
        else showNumber
      "
    >
      {{ 'label.noMaterialNumber' | translate }}
    </ng-container>
    <ng-template #showNumber>
      {{ coil.coilMaterialNumber }}
    </ng-template>
  </div>
  <div class="label-coil-serial-number">{{ coil.coilSerialNumber }}</div>

  <div
    *ngIf="!isReplacementCoilMaterialNumber(+coil.coilMaterialNumber)"
    class="replacement-part replacement-part-number"
  >
    <sh-icon size="s" icon="{{ coil.spcIcon }}" color="{{ coil.spcIconColor }}">
    </sh-icon>
    <sh-text
      size="body-2"
      class="link"
      (click)="onClickOpenUrl(coil?.urlToSPC)"
    >
      SPC{{ coil.coilMaterialNumber }}
    </sh-text>
  </div>

  <div
    [style.visibility]="isRelevantInfoVisible(coil?.coilName)"
    class="replacement-part-visibility"
  >
    <div
      class="replacement-part further-information-label"
      *ngFor="let link of coilservice.getExternalLinks().slice(0, 1)"
    >
      <div class="relevant-info" *ngFor="let innerLink of link.links">
        <sh-icon
          size="s"
          icon="{{ innerLink.icon }}"
          color="{{ innerLink.iconColor }}"
        >
        </sh-icon>
        <sh-text
          size="body-2"
          class="link"
          (click)="onClickOpenUrl(innerLink.url)"
        >
          {{ innerLink.linkText }}
        </sh-text>
      </div>
    </div>
  </div>
</div>
